module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_electronics-7dc6e2f7.png";